/* eslint-disable */
import { CommonPost, CommonGet } from '../../helpers/HttpClient';

export default {
    GetUsersByFilter,
    GetAllGroups,
    GetFactoriesByGroupID
};

async function GetUsersByFilter(role, group, factory) {
    const body = {
        roleID: parseInt(role),
        groupID: parseInt(group),
        factoryID: parseInt(factory)
    }
    const response = await CommonPost('/api/User/getUserDetailsByFilter', null, body);
    return response;
}

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}